import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "@/routes/root";
import { LoginPage } from "@/features/auth/components/LoginPage";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/login",
  staticData: { title: "Login" },
  component: LoginPage,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});
